import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-090ee8e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-pt-[10px] tw-justify-center" }
const _hoisted_2 = { class: "tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]" }
const _hoisted_3 = { class: "tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-normal tw-font-normal tw-mr-[7px]" }
const _hoisted_4 = { class: "tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-pt-[10px] tw-justify-center" }
const _hoisted_6 = { class: "tw-text-[14px] tw-font-poppins tw-text-[#231F20] tw-leading-[100%] tw-font-medium tw-mr-[7px] tw-mb-[4px]" }
const _hoisted_7 = { class: "tw-text-[12px] tw-font-poppins tw-text-[#878787] tw-leading-normal tw-font-normal tw-mr-[7px]" }
const _hoisted_8 = { class: "tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF]" }

import ToggleSwitch from "../common/toggleSwitch.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'moreDetails',
  props: {
  classesMoreDetail: {
    type: String,
    default: "",
  },
  isShowQuestions: {
    type: Boolean,
    default: true,
  },
  isShowButtonBelow: {
    type: Boolean,
    default: true,
  },
  isDetails: {
    type: String,
    default: "",
  },
  isDetailsValidate: {
    type: String,
    default: "",
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





let isMoreDetails = ref(false);

const changeMoreDetail = (value: any) => {
  isMoreDetails.value = value;
  emit("update:modelValue", value);
};
watchEffect(() => {
  if (props.isDetails) {
    isMoreDetails.value = true;
    emit("update:modelValue", true);
  }
});
watchEffect(() => {
  if (props.isDetailsValidate) {
    isMoreDetails.value = true;
    emit("update:modelValue", true);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.isShowButtonBelow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"height":"56px"},
          class: _normalizeClass([
      'tw-flex tw-leading-[100%] !tw-justify-between  tw-gap-[10px] tw-bg-[#ffffff] tw-rounded-md tw-p-[25px] tw-mb-[10px]',
      __props.classesMoreDetail,
    ])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-wizard-more-detail-title-1",
            )), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-wizard-more-detail-sub-title-1",
            )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ToggleSwitch, {
              "is-checked": _unref(isMoreDetails),
              color: "#2573E9",
              "onUpdate:isChecked": changeMoreDetail
            }, null, 8, ["is-checked"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (__props.isShowButtonBelow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: {"height":"56px"},
          class: _normalizeClass([
      'tw-flex tw-leading-[100%] tw-justify-between  tw-gap-[10px] tw-bg-[#ffffff] tw-rounded-md tw-p-[25px] more__detail',
      __props.classesMoreDetail,
    ])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-wizard-more-detail-title-1",
            )), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-wizard-more-detail-sub-title-1",
            )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ToggleSwitch, {
              "is-checked": _unref(isMoreDetails),
              color: "#2573E9",
              "onUpdate:isChecked": changeMoreDetail
            }, null, 8, ["is-checked"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})